import * as React from 'react';
import styled from "react-emotion";
import "bulma/css/bulma.css";
import {toast} from "react-toastify";

const KeyContainer = styled("div")`
    padding: 10px;
    word-wrap: anywhere;'
`;

const ShowHideSpan = styled("span")`
    font-weight: bold;
    margin-left: 10px;
    cursor: pointer;
`;

interface IAPIKeysProps {
    data: any;
    onEdit: any;
    onDelete: any;
}

interface IAPIKeysState {
    id: number;
    name: string;
    apiKey: string;
    keyVisible: boolean;
    dropDownVisible: boolean;
}

class APIKey extends React.Component<IAPIKeysProps, IAPIKeysState> {
    public stars: string = "";
    public menuRef: any = null;

    public constructor(props: IAPIKeysProps) {
        super(props);

        for (let i = 0; i < 10; i++) {
            this.stars += "*";
        }

        const data = props.data;

        this.state = {
            id: data.id,
            name: data.name,
            apiKey: data.api_key,
            keyVisible: false,
            dropDownVisible: false
        };

        this.menuRef = React.createRef();
    }

    public copyApiKey = () => {
        const textarea = document.createElement('textarea');
        textarea.value = this.state.apiKey;
        document.body.appendChild(textarea);
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        document.execCommand('copy');
        document.body.removeChild(textarea);

        toast.success("Copied to clipboard!");
    };

    public render() {
        return <div style={{marginBottom: '10px'}}>
            <div style={{marginBottom: '5px'}}>
                <span style={{
                    fontSize: '20px',
                    fontWeight: 'bold'
                }}>{this.state.name}</span>
                <div style={{
                    float: 'right'
                }}>
                    <div className={"dropdown is-right is-hoverable"}>
                        <div className="dropdown-trigger">
                            <button style={{border: 0}} className="button" aria-haspopup="true" aria-controls="dropdown-menu">
                                <span className="icon is-small">
                                    <i className="fas fa-ellipsis-v" aria-hidden="true"/>
                                </span>
                            </button>
                        </div>
                        <div className="dropdown-menu" id="dropdown-menu" role="menu">
                            <div className="dropdown-content">
                                <a href="#" className="dropdown-item" onClick={() => {
                                    this.props.onEdit();
                                }}>
                                    Edit
                                </a>
                                <a className="dropdown-item"onClick={() => {
                                    this.props.onDelete();
                                }}>
                                    Delete
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                this.state.keyVisible ? <KeyContainer>{this.state.apiKey}<i className="far fa-copy" aria-hidden={true}
                                                                            onClick={this.copyApiKey} title="Copy"
                                                                            style={{
                                                                                margin: '0 5px',
                                                                                cursor: 'pointer'
                                                                            }}/>
                    <ShowHideSpan style={{
                        fontWeight: 'bold',
                        marginLeft: '10px',
                        cursor: 'pointer'
                    }} onClick={() => {
                        this.setState({
                            keyVisible: false
                        });
                    }}>Hide</ShowHideSpan>
                </KeyContainer> : <KeyContainer>
                    {this.state.apiKey.substr(0, 10) + this.stars}
                    <i className="far fa-copy" aria-hidden={true} onClick={this.copyApiKey} title="Copy" style={{
                        margin: '0 5px',
                        cursor: 'pointer'
                    }}/>
                    <ShowHideSpan style={{}} onClick={() => {
                        this.setState({
                            keyVisible: true
                        });
                    }}>Show</ShowHideSpan>
                </KeyContainer>
            }
            <hr/>
        </div>;
    }
}

export default APIKey;


// WEBPACK FOOTER //
// ./src/routes/APIKeys/APIKey/index.tsx